import script from "./WebhardDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./WebhardDownload.vue?vue&type=script&setup=true&lang=js"

import "./WebhardDownload.vue?vue&type=style&index=0&id=cefbd17e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cefbd17e"]])

export default __exports__